import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
    selector: 'app-step-content',
    imports: [],
    templateUrl: './step-content.component.html',
    styleUrl: './step-content.component.scss'
})
export class StepContentComponent {

  @Input() public steps: string[] = [];
  @Input() public stepIcons: string[] = [];
  @Input() public showProgress: boolean = true;
  @Input() public activeStep: number = 0;
  @Output() public  activeStepChange: EventEmitter<number> = new EventEmitter<number>();

  public setStep(activeStep: number): void {
    this.activeStepChange.emit(activeStep);
  }

}
